import React from 'react';
import Lottie from 'lottie-react';
import {Box, Typography, useTheme} from '@mui/material';
import robotAnimation from '../assets/robot-loading.json';

export const ChartLoadingAnimation: React.FC = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: 400,
                my: 2,
                border: isDark
                    ? '1px solid rgba(255,255,255,0.06)'
                    : '1px solid rgba(0,0,0,0.06)',
                borderRadius: 2,
                backgroundColor: isDark
                    ? 'rgba(26, 26, 26, 0.5)'
                    : 'rgba(248, 250, 252, 0.5)',
            }}
        >
            <Lottie
                animationData={robotAnimation}
                loop
                autoplay
                style={{width: 180, height: 180}}
            />
            <Typography
                variant="body2"
                sx={{
                    mt: 1,
                    color: isDark
                        ? 'rgba(255,255,255,0.5)'
                        : 'rgba(0,0,0,0.45)',
                    fontWeight: 500,
                    letterSpacing: '0.02em',
                }}
            >
                Generating chart…
            </Typography>
        </Box>
    );
};
